<template>
    <div class="l-ss-c-filter-label">
        {{ label }}
    </div>
</template>

<script>
    export default {
        props: {
            label: String,
        },
    };
</script>